import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import FieldTitle from './field-title'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import SegmentedControl from '../../segmented-control'
import CreationToolGradient from '../../../types/gradient'
import { StaircaseIcon } from '../../icons'
import CreationToolWatermarkPosition from '../../../types/watermark'

const Container = styled.div`
    grid-column: span 2;
`

const Ass = styled(StaircaseIcon)<{ rotation: number }>`
    height: 20px;
    transform: rotate(${props => props.rotation}deg);
`

type Props = {
    field: CreationToolSuperCutField
    defaultPosition?: CreationToolWatermarkPosition
    gradient?: CreationToolGradient
}

const CreationCaptureWatermarkPositionSlider = ({ field, gradient = CreationToolGradient.PurpleRed }: Props) => {
    const { watermark, previousWatermarks, setWatermarkPosition } = useContext(CreationCaptureInfoContext)

    const icons = CreationToolWatermarkPosition.all().map((pos, i) => {
        return <Ass key={i} rotation={CreationToolWatermarkPosition.rotation(pos)} />
    })

    const onChange = (index: number) => {
        setWatermarkPosition(CreationToolWatermarkPosition.all()[index])
    }

    return (
        <>
            {previousWatermarks.length > 0 && watermark ? (
                <Container>
                    <FieldTitle field={field} />
                    <SegmentedControl
                        {...{
                            // TODO: Figure out how to store watermark position and set the defaultIndex accordingly.
                            gradient,
                            items: icons,
                            onIndexChange: index => onChange(index),
                        }}
                    />
                </Container>
            ) : null}
        </>
    )
}

export default CreationCaptureWatermarkPositionSlider
